module.exports = __webpack_public_path__ + "img/member_lip2.456efa55.png";